import React from 'react';
import { Formik, Form, Field } from 'formik';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import TextField from 'components/Common/CustomFormikFields/TextField';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import EmailAPI from 'api/EmailAPI';

interface IServiceAccountFormProps {
  admin: any;
}

const formValSchema = Yup.object().shape({
  service_acct_email: Yup.string().required('Service account email is required'),
  service_acct_name: Yup.string().required('Service Account Group Name is required')
});

const ServiceAccountForm = (props: IServiceAccountFormProps) => {
  const { admin } = props;
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const handleSubmit = async(formVals: any) => {
    await EmailAPI.serviceAccountRequest(formVals)
      .then((res) => {
        if (res?.success) {
          enqueueSnackbar('Service Account Request submitted', { variant: 'success' });
          history.push('/teams');
        } else {
          const message: string = res && res.result && typeof res.result === 'string' ? res.result : 'Unable to submit request for service account';
          enqueueSnackbar(message, { variant: 'error' });
        }
      })
      .catch(() => {
        enqueueSnackbar('Unable to submit request for service account', { variant: 'error' });
      });
  };
  return (
    <Formik
      initialValues={{
        team_admin_id: admin.basics.email,
        admin_phone: '',
        admin_name: `${admin.basics.firstName } ${ admin.basics.lastName}`,
        service_acct_email: '',
        service_acct_name: '',
        selected_team: admin.selected_team ? admin.selected_team.name : 'N/A'
      }}
      onSubmit={handleSubmit}
      validationSchema={formValSchema}
    >
      {({ values, errors, touched, submitForm }) =>
        <Form>
          <div>
            <Field
              component={TextField}
              fullWidth
              id='disabled-input'
              label='Team Admin Email'
              variant='outlined'
              type='text'
              className='vault-search-input workflow-input-spacing disabled-input'
              name='team_admin_id'
              value={values.team_admin_id}
              InputProps={{
                readOnly: true,
              }}
            />
            <Field
              component={TextField}
              fullWidth
              id='disabled-input'
              label='Team Admin Name'
              variant='outlined'
              type='text'
              className='vault-search-input workflow-input-spacing disabled-input'
              name='admin_name'
              value={values.admin_name}
              InputProps={{
                readOnly: true,
              }}
            />
            <Field
              component={TextField}
              fullWidth
              label='Team Admin Phone Number'
              variant='outlined'
              type='text'
              className='vault-search-input workflow-input-spacing'
              name='admin_phone'
              value={values.admin_phone}
            />
            <Field
              component={TextField}
              fullWidth
              label='Service Account Email'
              variant='outlined'
              type='text'
              className='vault-search-input workflow-input-spacing'
              name='service_acct_email'
              value={values.service_acct_email}
            />
            <Field
              component={TextField}
              fullWidth
              label='Service Account Group Name'
              variant='outlined'
              type='text'
              className='vault-search-input workflow-input-spacing'
              name='service_acct_name'
              value={values.service_acct_name}
            />
            {errors?.service_acct_name && touched?.service_acct_name ?
              <div style={{ color: 'red' }}>{errors.service_acct_name}</div> :
              null}
          </div>
          <div className='d-flex justify-content-end'>
            <Button variant='contained' onClick={submitForm} className='Theme-Btn'>
              Submit
            </Button>
          </div>
        </Form>
      }</Formik>
  );
};

export default ServiceAccountForm;
